// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Dt9m","bigColWidth":"Table_bigColWidth__2Mxse","biggerColWidth":"Table_biggerColWidth__3rC3D","row":"Table_row__10Do3","col":"Table_col__3bY6t"};